import Vue from "vue"
// import moment from 'moment';
import moment from 'moment-timezone';

Vue.filter("formatDate", (date) => {
    // Dec 8, 2020; 11:43
    return moment(date).format('MMM DD, YYYY; h:mm a');
})

Vue.filter("formatDate2", (date) => {
    // 8 Dec 2020
    return moment(date).format('DD MMM YYYY');
})

Vue.filter("agendaDate", (date, endDate, hideTime = false) => {
    if(moment(date).isSame(endDate, 'day')) {
        if(hideTime) {
            return `${moment(date).format('D MMM YYYY')}`
        }
        return `${moment(date).format('D MMM YYYY H:mm')}-${moment(endDate).format('H:mm')}`
    }
    if(hideTime) {
        return `${moment(date).format('D MMM YYYY')}-${moment(endDate).format('D MMM YYYY')}`
    }
    return `${moment(date).format('D MMM YYYY H:mm')}-${moment(endDate).format('D MMM YYYY H:mm')}`
})

Vue.filter("agendaDate2", (date, endDate, timezone, hideTime = false) => {
    if(moment(date).isSame(endDate, 'day')) {
        if(hideTime) {
            return `${moment.tz(date, timezone).tz(moment.tz.guess()).format('D MMM YYYY (dddd)')}`
        }
        return `${moment.tz(date, timezone).tz(moment.tz.guess()).format('D MMM YYYY (dddd)')} <br>
        ${moment.tz(date, timezone).tz(moment.tz.guess()).format('H:mm')}-${moment.tz(endDate, timezone).tz(moment.tz.guess()).format('H:mm')}`
    }
    if(hideTime) {
        return `From: <br>
            ${moment.tz(date, timezone).tz(moment.tz.guess()).format('D MMM YYYY (dddd)')}<br>
            To:<br>
            ${moment.tz(endDate, timezone).tz(moment.tz.guess()).format('D MMM YYYY (dddd)')}`
    }
    return `From: <br>
    ${moment.tz(date, timezone).tz(moment.tz.guess()).format('D MMM YYYY (dddd)')}
    ${moment.tz(date, timezone).tz(moment.tz.guess()).format('H:mm')} <br>
    To:<br>
    ${moment.tz(endDate, timezone).tz(moment.tz.guess()).format('D MMM YYYY (dddd)')}
    ${moment(endDate).format('H:mm')}`
})
